import { apiSlice } from "../../app/api/apiSlice";
import { ApiResponse, BookingObj, TourObj } from "../../shared/types";

type CheckoutSessionResponse = {
    status: string;
    session: { url: string };
};

type MyBookingsData = {
    bookings: BookingObj[];
    tours: TourObj[];
};

export const bookingsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getBookings: builder.query<ApiResponse<BookingObj[]>, void>({
            query: () => ({ url: "/api/v1/bookings" }),
            keepUnusedDataFor: 10,
        }),
        getCheckoutSession: builder.query<
            CheckoutSessionResponse,
            { tourId: string; startDate: string }
        >({
            query: ({ tourId, startDate }) => ({
                url: `/api/v1/bookings/checkout-session/${tourId}/${startDate}`,
            }),
            keepUnusedDataFor: 10,
        }),
        getCreateBooking: builder.query<
            ApiResponse<MyBookingsData>,
            {
                tour: string;
                user: string | null;
                price: string | null;
                startDate: string | null;
            }
        >({
            query: ({ tour, user, price, startDate }) => ({
                url: `/api/v1/bookings/my-tours/?tour=${tour}&user=${user}&price=${price}&startDate=${startDate}`,
            }),
            keepUnusedDataFor: 10,
        }),
        getMyBookings: builder.query<ApiResponse<MyBookingsData>, void>({
            query: () => ({ url: `/api/v1/bookings/my-tours` }),
            keepUnusedDataFor: 10,
        }),
    }),
})

export const {
    useGetBookingsQuery,
    useLazyGetCheckoutSessionQuery,
    useGetCreateBookingQuery,
    useGetMyBookingsQuery,
} = bookingsApiSlice
